import request from '@/utils/request'

/**
 * 获取角色列表
 * @returns {*}
 */
export function getGroupList() {
  return request.post('/phalapi/public/?service=App.Auth.Groups')
}

/**
 * 获取用户userid
 * @returns {*}
 */
export function getUserid() {
  return request.post('/phalapi/public/?service=App.Auth.getUserid')
}
